module.exports = __webpack_public_path__ + "img/import-loading.f7aaf114.gif";